import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import constants from '../Constants';
import { mmDDYYYY } from '../utils/placeHolderFormat';
import testCases from '../data/testCases';
import {loadTestData} from './actions';

const validateName = (message) => {
    return message;
}

const validate = values => {

    const errors = {};
    if (!values.GivenName) {
        errors.GivenName = validateName('First name is required');
    }
    else if (values.GivenName.trim().length === 0) {
        errors.GivenName = validateName('First name is required');
    }

    if (!values.Surname) {
        errors.Surname = validateName('this is required');
    }
    else if (values.Surname.trim().length === 0) {
        errors.SurName = validateName('this is required');
    }

    //begin dob
    if (!values.DOB) {
        errors.DOB = 'Date of birth is required';
    }
    else if (values.DOB.trim().length > 0) {
        let pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
        if (pattern.test(values.DOB) === false) {
            errors.DOB = 'Please enter a valid date of birth';
        }
    }
    //end dob

    //begin street validation
    if (!values.Street1) {
        errors.Street1 = 'test is required';
    }
    else if (values.Street1.trim().length === 0) {
        errors.Street1 = 'test is required';
    }
    else {
        let pattern = /^\s*\S+(?:\s+\S+){2}/;

        console.log(values.Street1);
        console.log(pattern.test(values.Street1));
        if (pattern.test(values.Street1) === false) {
            errors.Street1 = 'Please enter a valid street name';
        }
    }

    //begin city validation
    if (!values.City) {
        errors.City = 'test is required';
    }

    if (!values.StateCode) {
        errors.StateCode = 'test is required';
    }

    if (!values.Zip) {
        errors.Zip = 'test is required';
    }
    else if (values.Zip.length > 0) {
        let pattern = /^[0-9]{5}(?:-[0-9]{4})?$/;

        if (!pattern.test(values.Zip)) {
            errors.Zip = 'this is not a valid zipcode'
        }

    }

    return errors;
};
const style={
    animationDelay: '1.5s'
};
const renderField = ({ input, label, type, meta: { touched, error, warning }, placeholder }) => (
    
    <div style={style} className='form-group animated zoomIn'>
        <label>{label}</label>
        <div>
            <input
                className="form-control"
                {...input}
                placeholder={placeholder}
                type={type} />
            {touched && ((error && <span className="app-form-validation">{error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
)




let StartForm = props => {
    const { handleSubmit, load, isTokenRecieved } = props
   
    function changeTest(event){
        const index = event.target.value;

        load(testCases[index]);
    }

    const DemoSelect = (props)=>{
        return (
            <select className="form-control" onChange={changeTest}>
                <option>
                    Select a test case
                </option>
            {testCases.map((test, index) => {
                return (
                    <option key={index} value={index}>
                            {`${test['GivenName']} `}
                            {test['Surname']}
                    </option>
                );
            })}
        </select>
        );
    }
    console.log(props.state.quoteStart.underWriting);
    return (
        <form onSubmit={handleSubmit} className='form-group animated zoomIn'>
            {props.state.quoteStart.underWriting === undefined?<p className="alert alert-warning">This dropdown is used for demo/development purposes.</p>:null}
            <div className="formGroup">
            {props.state.quoteStart.underWriting === undefined?<DemoSelect />:<div className="alert alert-info" role="alert">Please refresh your browser for the test cases dropdown.</div>}
            <br/>
            </div>
            <h1>We need a few details to start</h1>
            <div>
                <Field
                    name="GivenName"
                    type="text"
                    label="First name"
                    component={renderField} />
            </div>
            <div>
                <Field
                    name="Surname"
                    type="text"
                    label="Last name"
                    component={renderField} />
            </div>
            <div>
                <Field
                    name="DOB"
                    type="text"
                    placeholder={mmDDYYYY}
                    label="Date of birth"
                    component={renderField} />
                {/*
                <label htmlFor="Driver.DOB">Date of Birth</label>
                <Field name="Driver.DOB" component="input" type="text" />
                */}
            </div>
            <div>
                <Field
                    name="Street1"
                    type="text"
                    label="Address"
                    component={renderField} />
            </div>
            <div>
                <Field
                    name="City"
                    type="text"
                    label="City"
                    component={renderField} />
            </div>
            <div>
                <Field
                    name="StateCode"
                    type="text"
                    label="State"
                    component={renderField} />
            </div>
            <div>
                <Field
                    name="Zip"
                    type="text"
                    label="Zip"
                    component={renderField} />
            </div>
            <div className="app-form-actions">
                <button
                    disabled={isTokenRecieved === false}
                    className="btn btn-primary"
                    type="submit">
                    {`Start `}
                    <i className={constants.icons.next} />
                </button>
                <div style={{
                    marginTop: '1em',
                    fontSize: '0.8em'
                    }}>
                <p>To offer you an accurate quote, we will use information from you, 
                    potential members of your household, and other sources, such as 
                    your driving, claims, and credit histories. Please review our 
                    <a href="javascript:void(0);"> Privacy Policy</a> and information about our use of consumer reports.  
                    Prices and products may vary based on how you buy (e.g., mobile, 
                    tablet, phone, agent etc.). Please answer all questions accurately, 
                    as information discovered only by ordering consumer reports may cause 
                    rates to be higher than if disclosed by you.</p>
                </div>
            </div>
        </form>
    )
}

StartForm = reduxForm({
    // a unique name for the form
    form: 'startForm',
    validate,
    enableReinitialize: true,
    destroyOnUnmount: false
})(StartForm);

StartForm = connect(
    state => ({
        initialValues: state.quoteStart.testData,
        state: state
    }),
    {
        load:loadTestData
    }
)(StartForm);

export default StartForm


// WEBPACK FOOTER //
// ./src/StartQuote/StartForm.js